<template>
  <div ref="form">
    <div class="section-title mb-3 mt-2">
      <span class="label">Endereço</span>
    </div>
    <input-cep
      v-model="cadastro.cep"
      field="cep"
      class="col-100"
      :validator="{ required: true, min: 9 }"
      :selectedCountryLocal="selectCountryLocal"
      @clear="clearAddressInputs"
      @set-country-local="setCountryLocal"
      @via-cep-data="handleViaCepData"
    />
    <input-uf v-model="cadastro.uf" field="uf" class="col-50" :validator="{ required: true }" :selectedCountryLocal="selectCountryLocal" />
    <input-cidade
      v-model="cadastro.cidade"
      field="cidade"
      class="col-50"
      :validator="{ required: true, cidadeValida: true }"
      :selectedCountryLocal="selectCountryLocal"
      :disabled="!cadastro.uf"
      :uf="cadastro.uf"
    />
    <input-bairro v-model="cadastro.bairro" field="bairro" class="col-100" :validator="{ required: true, min: 2 }" />
    <input-logradouro v-model="cadastro.logradouro" field="logradouro" class="col-100" :validator="{ required: true, min: 2 }" />
    <input-numero v-model="cadastro.numero" field="numero" class="col-50" :validator="{ required: true, max: 7 }" />
    <input-complemento v-model="cadastro.complemento" field="complemento" class="col-50" />
    <input-ponto-referencia v-model="cadastro.pontoReferencia" field="pontoReferencia" class="col-100" />
  </div>
</template>
<script>
import { data as cidades } from '@/config/cidades.json'

import InputBairro from './FormAddress/InputBairro'
import InputCep from './FormAddress/InputCep'
import InputCidade from './FormAddress/InputCidade'
import InputComplemento from './FormAddress/InputComplemento'
import InputLogradouro from './FormAddress/InputLogradouro'
import InputNumero from './FormAddress/InputNumero'
import InputPontoReferencia from './FormAddress/InputPontoReferencia'
import InputUf from './FormAddress/InputUf'

export default {
  name: 'FormAddress',
  inject: ['$validator'],
  components: {
    InputBairro,
    InputCep,
    InputCidade,
    InputComplemento,
    InputLogradouro,
    InputNumero,
    InputPontoReferencia,
    InputUf
  },
  props: {
    id: String,
    value: String,
    label: String,
    width: {
      type: Number,
      default: 100
    },
    field: String,
    validator: Object,
    backend: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    error: null,
    disabledFields: [],
    selectCountryLocal: '',
    cadastro: {
      cep: '',
      uf: '',
      cidade: '',
      bairro: '',
      logradouro: '',
      numero: '',
      complemento: '',
      codCidade: '',
      pontoReferencia: ''
    },
    firstLoad: true
  }),
  computed: {
    isBrazilSelectedCountry() {
      return this.selectCountryLocal === 'BRASIL'
    },
    componentValue() {
      const city = String(this.cadastro.cidade.Codigo || '')
      const obj = {
        [this.field]: {
          postal_code: this.cadastro.cep,
          street: this.cadastro.logradouro,
          neighborhood: this.cadastro.bairro,
          number: this.cadastro.numero,
          complement: this.cadastro.complemento,
          city: city && parseInt(city),
          city_name: this.isBrazilSelectedCountry ? this.cadastro.cidade.Nome : this.cadastro.cidade,
          federative_unit: this.cadastro.uf,
          country: this.selectCountryLocal,
          landmark: this.cadastro.pontoReferencia
        }
      }
      return this.extra_data ? { extra_data: obj } : obj
    }
  },
  watch: {
    'cadastro.uf'() {
      if (this.firstLoad) return
      if (this.isBrazilSelectedCountry) {
        this.cadastro.cidade = {}
      }
    },
    cadastro() {
      this.$emit('update:value', this.cadastro)
    },
    isBrazilSelectedCountry(isTrue) {
      if (isTrue && typeof this.cadastro.cidade === 'string') {
        this.cadastro.cidade = {
          Nome: this.cadastro.cidade
        }
      } else if (!isTrue) {
        this.cadastro.cidade = this.cadastro.cidade.Nome
        this.cadastro.cep = this.cadastro.cep.replaceAll('-', '')
      }
    }
  },
  created() {
    if (this.$store.getters.USER_INFO[this.field] && this.$store.getters.USER_INFO[this.field].country) {
      this.selectCountryLocal = this.$store.getters.USER_INFO[this.field].country
    } else {
      this.selectCountryLocal = this.$store.getters.SELECTED_COUNTRY
    }
  },
  mounted() {
    if (this.$store.getters.TOKEN && this.$store.getters.USER_INFO[this.field]) {
      this.cadastro = {
        cep: this.isBrazilSelectedCountry
          ? this.$store.getters.USER_INFO[this.field].postal_code || ''
          : this.$store.getters.USER_INFO[this.field].postal_code.replaceAll('-', '') || '',
        uf: this.$store.getters.USER_INFO[this.field].federative_unit || '',
        ...(this.isBrazilSelectedCountry
          ? {
              cidade: {
                Nome: this.$store.getters.USER_INFO[this.field].city_name,
                Codigo: this.$store.getters.USER_INFO[this.field].city
              }
            }
          : {
              cidade: this.$store.getters.USER_INFO[this.field].city_name
            }),
        bairro: this.$store.getters.USER_INFO[this.field].neighborhood || '',
        logradouro: this.$store.getters.USER_INFO[this.field].street || '',
        numero: this.$store.getters.USER_INFO[this.field].number || '',
        complemento: this.$store.getters.USER_INFO[this.field].complement || '',
        codCidade: this.$store.getters.USER_INFO[this.field].city ? parseInt(String(this.$store.getters.USER_INFO[this.field].city)) : '',
        pontoReferencia: this.$store.getters.USER_INFO[this.field].landmark || ''
      }
      this.$nextTick(() => {
        this.firstLoad = false // this avoids triggering 'watch' hook for 'cadastro.uf' which will set 'cidade' to void object on first load
      })
    }
  },
  methods: {
    setCountryLocal(country) {
      this.selectCountryLocal = country
    },
    handleViaCepData(data) {
      let ibgeCidade = {}
      let bairroFound = false
      if (data.uf) {
        this.cadastro.uf = data.uf
      }
      if (data.ibge) {
        ibgeCidade = cidades.find(cidade => String(cidade.Codigo) === String(data.ibge))
      }
      if (data.bairro) {
        this.cadastro.bairro = data.bairro
        bairroFound = true
      }
      if (data.logradouro) {
        this.cadastro.logradouro = data.logradouro
      }

      this.$nextTick(() => {
        if (ibgeCidade) {
          this.cadastro.cidade = ibgeCidade
        }
        if (data.localidade) {
          // O retorno do viacep algumas vezes envia o bairro e a cidade juntos. Por padrão,
          // a cidade vem entre parênteses. Por isso esse tratamento dos dados.
          let parsedCidade, parsedBairro
          if (data.localidade.includes('(') && data.localidade.includes(')')) {
            let [bairro, cidade] = data.localidade.split('(').map(obj => obj.trim().replace(')', ''))
            parsedCidade = cidade
            parsedBairro = bairro
          } else {
            parsedCidade = data.localidade
          }
          if (!Object.keys(ibgeCidade).length && parsedCidade) {
            // Busca cidade usando nome aqui? Cria cidade?
          }
          if (!bairroFound && parsedBairro) {
            this.cadastro.bairro = parsedBairro
          }
        }
      })
    },
    clearAddressInputs() {
      this.cadastro.cep = ''
      this.cadastro.uf = ''
      this.cadastro.cidade = ''
      this.cadastro.bairro = ''
      this.cadastro.logradouro = ''
      this.cadastro.numero = ''
      this.cadastro.complemento = ''
    },
    goToFirstInvalidField() {
      this.$nextTick(() => {
        const divs = this.$refs.form.children
        for (let x = 0; x < divs.length; x++) {
          const errorMessage = divs[x].querySelector('.v-messages__message')

          if (errorMessage) {
            const input = divs[x].querySelector('input')
            this.$vuetify.goTo(input, { offset: 200 })
            input.focus()
            return
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
span {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}
</style>
